const slatedBlocks = <NodeListOf<HTMLDivElement>>(
  document.querySelectorAll('.loentein-block[data-rotate]')
);

function sizeSlantedSiblings() {
  slatedBlocks.forEach((block) => {
    const blockBox = block.getBoundingClientRect();
    const sibling = <HTMLDivElement>block.nextElementSibling;

    if (!sibling) {
      return;
    }

    const siblingPadding = Math.round(blockBox.height) / 2;
    sibling.style.paddingTop = `${siblingPadding}px`;
    sibling.style.marginTop = `-${siblingPadding}px`;
  });
}

sizeSlantedSiblings();
window.addEventListener('resize', sizeSlantedSiblings);
